import { Injectable } from '@angular/core';
import { Inspection } from './inspection.dto';
import { map, Observable } from 'rxjs';
import { ObservableSyncService } from '../sync/observable-sync.service';
import { ChangeTyped, INSPECTIONS_STORE, mapSnapshotToDtos, QueryService, SearchResult } from '@damofire/data-commons';
import { ObservableInspectionService } from './inspection-observable.service';
import { TypedDesQuery } from '../des.dto';
import { ObservableNoteService } from '../note/note-observable.service';

@Injectable()
export class IdbObservableInspectionService extends ObservableInspectionService {
  constructor(
    protected readonly observableSyncService: ObservableSyncService<Inspection>,
    protected readonly observableNoteService: ObservableNoteService,
  ) {
    super(observableNoteService);
  }

  protected observeById(division: string, id: string): Observable<ChangeTyped<Inspection>> {
    return this.observableSyncService.toObservableById(INSPECTIONS_STORE, division, id);
  }

  noteableSearch(id: string, sQuery: TypedDesQuery): Observable<SearchResult<Inspection>> {
    let previousResults: Inspection[] = [];
    return this.observableSyncService.toObservable(INSPECTIONS_STORE, id).pipe(
      map((changes) => {
        mapSnapshotToDtos(previousResults, changes);
        const searchResults = QueryService.searchCollection<Inspection>(previousResults, sQuery, this.SEARCH_FIELDS);
        previousResults = searchResults.result;
        return searchResults;
      }),
    );
  }
}
